var MultiComparisons, MultiComparisonsActions, MultiComparisonsListView, MultiComparisonsMarketingScreen, MultiComparisonsStore, MultiComparisonsToolbar, ReactComponent, ReactToolbarView, View, alt, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

alt = require('alt');

mediator = require('mediator');

View = require('base/views/view');

ReactComponent = require('base/lib/traits/react_component');

MultiComparisonsMarketingScreen = require('components/multi_comparisons/multi_comparisons_marketing_screen');

ReactToolbarView = require('views/react_toolbar_view');

MultiComparisons = require('components/multi_comparisons/multi_comparisons');

MultiComparisonsToolbar = require('components/multi_comparisons/multi_comparisons_toolbar');

MultiComparisonsActions = require('actions/multi_comparisons_actions');

MultiComparisonsStore = require('stores/multi_comparisons_store');

module.exports = MultiComparisonsListView = (function(_super) {
  __extends(MultiComparisonsListView, _super);

  function MultiComparisonsListView() {
    return MultiComparisonsListView.__super__.constructor.apply(this, arguments);
  }

  MultiComparisonsListView.prototype.container = '#page-container';

  MultiComparisonsListView.prototype.className = 'multi-comparisons-view';

  MultiComparisonsListView.prototype.autoRender = true;

  MultiComparisonsListView.prototype.initialize = function() {
    MultiComparisonsListView.__super__.initialize.apply(this, arguments);
    this.subview('toolbar', new ReactToolbarView({
      component: MultiComparisonsToolbar
    }));
    return this.enable(ReactComponent);
  };

  MultiComparisonsListView.prototype.afterRender = function() {
    MultiComparisonsListView.__super__.afterRender.apply(this, arguments);
    this._stopInputsPropagation = false;
    if (mediator.services.switches.isOn('multiComparisons')) {
      return this.renderSimpleComponent(MultiComparisons);
    } else {
      return this.renderSimpleComponent(MultiComparisonsMarketingScreen);
    }
  };

  MultiComparisonsListView.prototype.dispose = function() {
    this.unmountComponent();
    return MultiComparisonsListView.__super__.dispose.apply(this, arguments);
  };

  return MultiComparisonsListView;

})(View);
